<template>
  <div class="consent-page">
    <b-container class="py-5">
      <b-row class="justify-content-center">
        <b-col cols="12" md="6">
          <b-card v-if="loading" class="text-center py-5">
            <b-spinner />
            <p class="mt-2">Loading consent details...</p>
          </b-card>

          <b-card v-else-if="error" class="text-center py-5">
            <h5 class="text-danger">{{ error }}</h5>
          </b-card>

          <b-card v-else-if="consent" class="text-center">
            <h4 class="mb-3">ABHA Consent Request</h4>
            <hr />
            <p><strong>Patient Name:</strong> {{ consent.first_name }} {{ consent.last_name }}</p>
            <p><strong>Hospital:</strong> {{ consent.hospital_name }}</p>
            <p class="mt-3">
              By approving, you consent to the creation of an ABHA (Ayushman Bharat Health Account)
              ID linked to your health records in the SOTTO Karnataka Transplant System.
            </p>

            <div v-if="consent.consent_status === 'PENDING'" class="mt-4">
              <b-button variant="success" class="mr-2" @click="submitConsent('APPROVED')">
                Approve
              </b-button>
              <b-button variant="danger" @click="submitConsent('REJECTED')">
                Reject
              </b-button>
            </div>

            <div v-else class="mt-4">
              <b-badge
                :variant="consent.consent_status === 'APPROVED' ? 'success' : 'danger'"
                class="p-2"
              >
                Consent {{ consent.consent_status }}
              </b-badge>
            </div>
          </b-card>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import http from "../assets/js/axios";

export default {
  data() {
    return {
      loading: true,
      error: "",
      consent: null,
      token: "",
    };
  },
  methods: {
    async loadConsent() {
      this.loading = true;
      try {
        const { data } = await http.get(
          "/recipient_registration/verify_consent/" + this.token
        );
        if (data.status && data.list && data.list.length > 0) {
          this.consent = data.list[0];
        } else {
          this.error = data.msg || "Invalid or expired consent link";
        }
      } catch (error) {
        this.error = "Unable to load consent details";
      }
      this.loading = false;
    },
    async submitConsent(status) {
      try {
        this.loading = true;
        const { data } = await http.post(
          "/recipient_registration/submit_consent",
          {
            consent_token: this.token,
            consent_status: status,
          }
        );
        if (data.status) {
          this.consent.consent_status = status;
        } else {
          this.error = data.msg || "Failed to update consent";
        }
        this.loading = false;
      } catch (error) {
        this.loading = false;
        this.error = "Error submitting consent";
      }
    },
  },
  mounted() {
    this.token = this.$route.params.token;
    if (this.token) {
      this.loadConsent();
    } else {
      this.error = "No consent token provided";
      this.loading = false;
    }
  },
};
</script>

<style scoped>
.consent-page {
  min-height: 100vh;
  background-color: #f8f9fa;
}
</style>
